module.exports = __webpack_public_path__ + "img/ico33.d0cfed5d.jpg";